import RequiredValidator from "@/validators/RequiredValidator";
import EmailValidator from "@/validators/EmailValidator";
import {RangeValidator} from "@/validators/RangeValidator";
import {EmploymentType, Gender, UserCreateType} from "@/helpers/constants";
import {enumToArray} from "@/helpers/functions_asi";
import {PasswordValidator} from "@/validators/PasswordValidator";

export default class UserRules {

	public static readonly companyIdRules = [
		(new RequiredValidator('company.singular')).validationRule(),
	];

	public static readonly userCreateTypeRules = [
		(new RequiredValidator('uiTerms.type')).validationRule(),
		(new RangeValidator('uiTerms.type', true, enumToArray(UserCreateType).map(u => u.value))).validationRule(),
	];

	public static readonly genderRules = [
		(new RequiredValidator('user.gender')).validationRule(),
		(new RangeValidator('user.gender', true, enumToArray(Gender).map(g => g.value))).validationRule(),
	];

	public static readonly firstnameRules = [
		(new RequiredValidator('user.firstname')).validationRule(),
	];

	public static readonly lastnameRules = [
		(new RequiredValidator('user.lastname')).validationRule(),
	];

	public static readonly countryCodeRules = [
		(new RequiredValidator('user.countryCode')).validationRule(),
	];

	public static readonly employmentTypeRules = [
		(new RangeValidator('user.employmentType', true, enumToArray(EmploymentType).map(e => e.value))).validationRule(),
	];

	public static readonly languageCodeRules = [
		(new RequiredValidator('user.languageCode')).validationRule(),
	];

	public static readonly timeZoneRules = [
		(new RequiredValidator('user.timeZone')).validationRule(),
	];

	public static readonly usernameRules = [
		(new RequiredValidator('user.username')).validationRule(),
		(new EmailValidator('user.username')).validationRule(),
	];

	public static passwordRules = [
		(new RequiredValidator('user.password')).validationRule(),
		(new PasswordValidator('user.password')).validationRule(),
	];

	public static readonly birthdayRules = [];

	public static readonly notesRules = [];

}
